import { actionCreator } from "src/store/dataService/actions/utils/actionCreator";
import { API } from "src/store/dataService/types";
import { Message, MessageType } from "Types/api/Messages";

/**
 * Post Conversation Start
 */
export const postConversationStartRequest = actionCreator("conversation_start/post/request", undefined, () => ({
    route: API.Messages,
}));

export const postStartConversationSuccess = actionCreator(
    "conversation_start/post/success",
    (response: BotStartResponse) => ({
        ...response,
    })
);

export const postStartConversationFailure = actionCreator("conversation_start/post/failure");

/**
 * Post Conversation Message
 */
export const postConversationMessageRequest = actionCreator(
    "conversation_message/post/request",
    (message: { text: string; tempId: string | MessageType.MessageLeft }) => ({
        message,
    }),
    () => ({ route: API.Messages })
);

export const postConversationMessageSuccess = actionCreator(
    "conversation_message/post/success",
    (tempId: string, message: Message) => ({
        tempId,
        message,
    })
);

export const postConversationMessageFailure = actionCreator(
    "conversation_message/post/failure",
    (message: { text: string; tempId: string }, reason: string) => ({
        message,
        reason,
    })
);

/**
 * GET Conversation Transcript
 */
export const getTranscriptRequest = actionCreator(
    "conversations_transcript/get/request",
    (token: string, channel: string) => ({
        token,
        channel,
    }),
    () => ({ route: API.Messages })
);

export const getTranscriptSuccess = actionCreator(
    "conversations_transcript/get/success",
    (response: VisitorTranscriptResponse) => ({
        ...response,
    })
);

export const getTranscriptFailure = actionCreator("conversations_transcript/get/failure");

/**
 * Pusher Message Handler
 */
export const handlePusherMessage = actionCreator("pusher_message/handle", (eventName: string, data: any) => ({
    eventName,
    data,
}));

/**
 * Toggle Notifications
 */
export const toggleChatNotifications = actionCreator("conversations_notifications/toggle");

export const openFromConversations = actionCreator(
    "open_from_conversations",
    (response: Pick<BotStartResponse, "token" | "channel">) => ({
        ...response,
    })
);

export const carryOverFromConversations = actionCreator(
    "carry_over_from_conversations",
    (response: Pick<BotStartResponse, "token" | "channel">) => ({
        ...response,
    })
);
